// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './root'
import { Route as authRoutesLoginRouteImport } from './auth/routes/login'
import { Route as crmRoutesLayoutRouteImport } from './crm/routes/layout'
import { Route as crmRoutesIndexRouteImport } from './crm/routes/index'
import { Route as crmRoutesSettingsRouteImport } from './crm/routes/settings'
import { Route as crmRoutesPlannerRouteImport } from './crm/routes/planner'
import { Route as crmRoutesPipelineRouteImport } from './crm/routes/pipeline'
import { Route as crmRoutesAnalyticsRouteImport } from './crm/routes/analytics'
import { Route as crmRoutesActivityRouteImport } from './crm/routes/activity'
import { Route as crmRoutesAccountsRouteImport } from './crm/routes/accounts'
import { Route as crmRoutesAccountsIdRouteImport } from './crm/routes/accounts/$id'

const authRoutesLoginRoute = authRoutesLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const crmRoutesLayoutRoute = crmRoutesLayoutRouteImport.update({
            id: '/_crm',getParentRoute: () => rootRouteImport
          })
const crmRoutesIndexRoute = crmRoutesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => crmRoutesLayoutRoute
          })
const crmRoutesSettingsRoute = crmRoutesSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => crmRoutesLayoutRoute
          })
const crmRoutesPlannerRoute = crmRoutesPlannerRouteImport.update({
            id: '/planner',path: '/planner',getParentRoute: () => crmRoutesLayoutRoute
          })
const crmRoutesPipelineRoute = crmRoutesPipelineRouteImport.update({
            id: '/pipeline',path: '/pipeline',getParentRoute: () => crmRoutesLayoutRoute
          })
const crmRoutesAnalyticsRoute = crmRoutesAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => crmRoutesLayoutRoute
          })
const crmRoutesActivityRoute = crmRoutesActivityRouteImport.update({
            id: '/activity',path: '/activity',getParentRoute: () => crmRoutesLayoutRoute
          })
const crmRoutesAccountsRoute = crmRoutesAccountsRouteImport.update({
            id: '/accounts',path: '/accounts',getParentRoute: () => crmRoutesLayoutRoute
          })
const crmRoutesAccountsIdRoute = crmRoutesAccountsIdRouteImport.update({
            id: '/accounts/$id',path: '/accounts/$id',getParentRoute: () => crmRoutesLayoutRoute
          })





const crmRoutesLayoutRouteChildren = {
  crmRoutesAccountsRoute: crmRoutesAccountsRoute,crmRoutesActivityRoute: crmRoutesActivityRoute,crmRoutesAnalyticsRoute: crmRoutesAnalyticsRoute,crmRoutesPipelineRoute: crmRoutesPipelineRoute,crmRoutesPlannerRoute: crmRoutesPlannerRoute,crmRoutesSettingsRoute: crmRoutesSettingsRoute,crmRoutesIndexRoute: crmRoutesIndexRoute,crmRoutesAccountsIdRoute: crmRoutesAccountsIdRoute
}

const crmRoutesLayoutRouteWithChildren = crmRoutesLayoutRoute._addFileChildren(crmRoutesLayoutRouteChildren)

const rootRouteChildren = {
  crmRoutesLayoutRoute: crmRoutesLayoutRouteWithChildren,authRoutesLoginRoute: authRoutesLoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)